import React, { useState } from 'react';

const MissingUnitWeightEditor = ({
  disabled = false,
  initialValue = '',
  triggerLabel = 'Falta peso',
  onSave,
}) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const closeEditor = () => {
    if (saving) return;
    setEditing(false);
    setValue('');
    setError('');
  };

  const saveWeight = async () => {
    const unitWeightKg = Number(value);
    if (String(value).trim() === '' || !Number.isFinite(unitWeightKg) || unitWeightKg <= 0) {
      setError('Ingresa un peso mayor a 0.');
      return;
    }

    setSaving(true);
    setError('');
    try {
      await onSave?.(unitWeightKg);
      setEditing(false);
      setValue('');
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'No se pudo guardar el peso.');
    } finally {
      setSaving(false);
    }
  };

  if (disabled || typeof onSave !== 'function') {
    return <span className="text-xs font-semibold text-amber-700">{triggerLabel}</span>;
  }

  if (!editing) {
    return (
      <button
        type="button"
        aria-label={initialValue ? 'Editar peso de unidad' : 'Agregar peso de unidad'}
        onClick={() => {
          setValue(String(initialValue ?? ''));
          setEditing(true);
        }}
        className="rounded px-1.5 py-0.5 text-xs font-semibold text-amber-700 underline decoration-dotted underline-offset-2 hover:bg-amber-100 hover:text-amber-900"
      >
        {triggerLabel}
      </button>
    );
  }

  return (
    <span className="inline-flex min-w-[210px] flex-col items-end gap-1">
      <span className="inline-flex items-center gap-1">
        <input
          type="number"
          aria-label="Peso de unidad en kg"
          min="0"
          step="any"
          inputMode="decimal"
          autoFocus
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
            setError('');
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              saveWeight();
            }
            if (event.key === 'Escape') {
              event.preventDefault();
              closeEditor();
            }
          }}
          disabled={saving}
          className={`h-8 w-24 rounded border px-2 text-right text-xs ${error ? 'border-red-400' : 'border-amber-300'}`}
        />
        <span className="text-xs text-gray-500">kg</span>
        <button
          type="button"
          onClick={saveWeight}
          disabled={saving}
          className="h-8 rounded bg-amber-700 px-2 text-xs font-semibold text-white hover:bg-amber-800 disabled:opacity-60"
        >
          {saving ? '...' : 'Guardar'}
        </button>
        <button
          type="button"
          aria-label="Cancelar peso de unidad"
          onClick={closeEditor}
          disabled={saving}
          className="h-8 rounded border border-gray-300 px-2 text-xs text-gray-600 hover:bg-gray-50 disabled:opacity-60"
        >
          ×
        </button>
      </span>
      {error && <span className="text-[11px] font-medium text-red-600">{error}</span>}
    </span>
  );
};

export default MissingUnitWeightEditor;
